import {
    Component, ViewChild, Input, Output, EventEmitter
} from '@angular/core';

import { HisAuthService, HisSearchResultComponent, HisSearchResultRow } from 'hisng';

import { PublicationService } from '../../../service/publication.service';
import { SEARCH_CONFIG_PUBLICATION_ORCID_USER } from 'app/fs/res/common/model/searchConstants';

@Component({
    selector: 'res-publication-search-orcid-user-result',
    templateUrl: './publication-search-orcid-user-result.component.html',
})
export class PublicationSearchOrcidUserResultComponent {
    @ViewChild(HisSearchResultComponent, { static: true }) searchResultComponent: HisSearchResultComponent;
    @Input() set search(search: any) {
        if (search) {
            this.searchResultComponent.loadPage(0, search);
        }
    }
    @Output() changeSearch = new EventEmitter();
    @Output() newSearch = new EventEmitter();
    @Output() doImport = new EventEmitter();

    readonly SEARCH_CONFIG_PUBLICATION_ORCID_USER = SEARCH_CONFIG_PUBLICATION_ORCID_USER;

    constructor(public auth: HisAuthService,
        public publicationService: PublicationService) {
    }

    generateTooltip = (row: HisSearchResultRow) => {
        return row.get('Person.firstname') + ' ' + row.get('Person.surname') + ' ' + row.get('[Orgunit].currentVersions.defaulttext');
    };

    public onNewSearch() {
        this.newSearch.emit();
    }

    public onChangeSearch() {
        this.changeSearch.emit();
    }

    public onDoImport() {
        this.doImport.emit({ search: this.searchResultComponent.search,
            selectedOptions: this.searchResultComponent.selectedOptions, allResults: this.searchResultComponent.rows });
    }

    get idAssignmentUrl() {
        return window.location.href.split('/a/')[0] + '/a/cs.psv.frontend/person/idAssignment';
    }
}
